/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React, { useState } from 'react';
import { Box, Button, Card, Typography } from '@mui/material';
import { Formik } from 'formik';
import * as Yup from 'yup';
import DialogContainer from '../../../../../../components/shared/Dialog/DialogContainer';
import { toast } from 'react-toastify';
import { getSecret, writeSecret } from '../../../../../../services/hashicorp/hashicorp';
import ViewUserSecretForm from './ViewUserSecretForm';
import { Tabs, Tab } from '@mui/material';
import CreateUserSecretForm from './CreateUserSecretForm';

const UserSecret = () => {
    const [open, setOpen] = useState(false);
    const [secretsDetails, setSecretsDetails] = useState({ password: "", username: "" });
    // Handle open/close dialog
    const handleOpen = () => setOpen(true);
    const handleClose = () => { setOpen(false); setSecretsDetails({ password: "", username: "" }) };

    const [activeTab, setActiveTab] = useState(0);


    // Handle form submission
    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            const secrets = await getSecret(values);
            setSecretsDetails(secrets);
            setSubmitting(false);
        } catch (error) {
            toast.error(error?.response?.data?.error?.message);
            setSubmitting(false);
        }
    };
    const handleSubmitCreation = async (values, { setSubmitting }) => {
        try {
            await writeSecret(values);
            toast.success('Secret was registred successfully');

            console.log('values', values);
            setSubmitting(false);
        } catch (error) {
            toast.error(error?.response?.data?.error?.message);
            setSubmitting(false);
        }
    };
    return (
        <>
            <Button variant="contained" color="primary" style={{ float: 'right' ,marginRight:"20px"}} onClick={handleOpen} >Manage User Secret</Button>
            {/* Dialog for Adding User */}
            <DialogContainer
                open={open}
                handleClose={handleClose}
            >
                <Box sx={{ mt: 2, }}>
                    {/* Tabs for Navigation */}
                    <Tabs value={activeTab} onChange={(e, newValue) => setActiveTab(newValue)} centered>
                        <Tab label="User Secret Details" />
                        <Tab label="Create User Secret" />
                    </Tabs>

                    {activeTab === 0 && (<>
                        <Formik
                            initialValues={{
                                getchkdid: '',
                                appName: '',
                            }}
                            validationSchema={Yup.object().shape({
                                getchkdid: Yup.string().required('Getchkd user is required.'),
                                appName: Yup.string().required('Application name is required.'),
                            })}
                            onSubmit={(
                                values, { setSubmitting }
                            ) => {
                                handleSubmit(values, { setSubmitting })
                            }
                            }
                        >
                            {({ values, handleBlur, handleChange, isSubmitting, setFieldValue, errors, touched }) => (
                                <ViewUserSecretForm
                                    values={values}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    setFieldValue={setFieldValue}
                                    isSubmitting={isSubmitting}
                                    handleClose={handleClose}
                                    errors={errors}
                                    touched={touched} />
                            )}
                        </Formik>

                        {secretsDetails && (secretsDetails?.username?.length > 0 || secretsDetails?.password?.length > 0) && (
                            <Card sx={{ mt: 3, p: 2, boxShadow: 3, borderRadius: 2 }}>

                                <Box sx={{ mt: 1, p: 1, borderRadius: 1 }}>
                                    <Typography variant="h4" style={{ marginBottom: '10px' }}>
                                        Username : {secretsDetails.username}
                                    </Typography>
                                    <Typography variant="h4" >
                                        Password : {secretsDetails.password}
                                    </Typography>
                                </Box>
                            </Card>
                        )}
                    </>
                    )}
                    {activeTab === 1 && (<>
                        <Formik
                            initialValues={{
                                getchkdid: '',
                                userName: '',
                                userPass: '',
                                appName: '',
                                confirmPassword: ''
                            }}
                            validationSchema={Yup.object().shape({
                                getchkdid: Yup.string().required('Getchkd user is required.'),
                                appName: Yup.string().required('Application name is required.'),
                                userName: Yup.string().required('User name is required.'),
                                userPass: Yup.string().required('Password is required.'),
                                confirmPassword: Yup.string()
                                    .min(8)
                                    .max(30)
                                    .oneOf([Yup.ref('userPass'), null], 'Passwords must match')
                                    .required('Password confirmation is required'),
                            })}
                            onSubmit={(
                                values, { setSubmitting }
                            ) => {
                                handleSubmitCreation(values, { setSubmitting })
                            }
                            }
                        >
                            {({ values, handleBlur, handleChange, isSubmitting, setFieldValue, errors, touched }) => (
                                <CreateUserSecretForm
                                    values={values}
                                    handleBlur={handleBlur}
                                    handleChange={handleChange}
                                    setFieldValue={setFieldValue}
                                    isSubmitting={isSubmitting}
                                    handleClose={handleClose}
                                    errors={errors}
                                    touched={touched} />
                            )}
                        </Formik>


                    </>
                    )}
                </Box>

            </DialogContainer>
        </>
    )

}

export default UserSecret;
